export enum WidgetsCategory {
  HIGHLIGHTED = 'highlightedWidgets',
  CUSTOMEREXPERIENCE = 'customerExperience',
  CUSTOMERBASEVALUE = 'customerBaseValue',
  SALESEFFICIENCY = 'salesEfficiency',
  ALL = 'allWidgets',
}

export enum AreaWidgetsCategory {
  OVERVIEW = 'overviewWidgets',
}

export enum WidgetType {
  NewMembers = 'NewMembers',
  PiecesPerReceipt = 'PiecesPerReceipt',
  ConversionRate = 'ConversionRate',
  HourlyTurnover = 'HourlyTurnover',
  TopSellingGarment = 'TopSellingGarment',
  ShareOfReceipts = 'ShareOfReceipts',
  AveragePurchaseWidget = 'AveragePurchaseWidget',
  QueueLengthWidget = 'QueueLengthWidget',
  AppCustomersWidget = 'AppCustomersWidget',
  AreaComparisonWidget = 'AreaComparisonWidget',
  CustomerFeedBackWidget = 'CustomerFeedBackWidget',
  SCOShareOfReceipts = 'SCOShareOfReceipts',
  RfidApprovalsWidget = 'RfidApprovalsWidget',
  RfidCountWidget = 'RfidCountWidget',
  RfidSalesRetagging = 'RfidSalesRetagging',
  OrisCustomersWidget = 'OrisCustomersWidget',
  EfficiencyWidget = 'EfficiencyWidget',
  CustomerEngagmentWidget = 'CustomerEngagmentWidget',
  SalesInsightsWidget = 'SalesInsightsWidget',
  StockAccuracyWidget = 'StockAccuracyWidget',
  HelpASaleWidget = 'HelpASaleWidget',
  BopisWidget = 'BopisWidget',
  BopisLeadTimeWidget = 'BopisLeadTimeWidget',
}

export type CategoryWidgetOrderMap = {
  [key in WidgetType]?: number;
};
